// extracted by mini-css-extract-plugin
module.exports = {"emojiCommentContainer":"styles_emojiCommentContainer__296lF","emojiPickerContainer":"styles_emojiPickerContainer__3X3CO"};